/**
 * 商城「Footer 設定」→「套用預設 Footer」建議連結欄。
 * 路徑為相對路徑，請於前台建立對應 CMS 頁或路由（slug 與路徑一致為佳）。
 */
export function createDefaultCommerceFooterColumns() {
  return [
    {
      title: '',
      links: [
        { label: '聯絡我們', href: '/page/contact', openInNewTab: false },
        { label: '關於我們', href: '/page/about', openInNewTab: false },
        { label: '隱私權政策', href: '/page/privacy', openInNewTab: false },
        { label: '服務條款', href: '/page/terms', openInNewTab: false },
      ],
    },
  ].map((col) => ({
    ...col,
    links: col.links.map((link) => ({ ...link })),
  }))
}
